import { generateQueryParams2 } from 'utils'
import CommonService from './common.service'
import { _object } from 'utils/interfaces'

class DealsService extends CommonService {
  async getDeals(params: _object) {
    return await this.get(`/deals?${generateQueryParams2(params)}`)
  }

  async addDeal(params: _object) {
    return await this.post('/deals', params)
  }

  async getDealDetails(id: string | undefined) {
    return await this.get(`/deals/${id}`)
  }

  async updateDeal(id: string | undefined, params: _object) {
    return await this.put(`/deals/${id}`, params)
  }

  async deleteDeal(id: string | undefined) {
    return await this.delete(`/deals/${id}`)
  }
  async dealOfTheWeek(params: _object) {
    return await this.post('/deals-of-week', params)
  }

  async getDealOfTheWeek() {
    return await this.get('/deals-of-week')
  }
}

export const dealsService = new DealsService()
